<div mat-dialog-title>{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.FORWARDING_ADDRESS_INFO_TITLE' | translate }}</div>
<mat-dialog-content>
  <div [innerHTML]="'INBOX.SETTINGS.EMAIL_SETTINGS.FORWARDING_ADDRESS_INFO' | translate"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-stroked-button>{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.CLOSE_BUTTON' | translate }}</button>
</mat-dialog-actions>
